import { userErrorFragment, checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

const checkoutLineItemsReplace = (
	`mutation ($checkoutId: ID!, $lineItems: [CheckoutLineItemInput!]!) {
		checkoutLineItemsReplace(checkoutId: $checkoutId, lineItems: $lineItems) {
			userErrors ${userErrorFragment}
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutLineItemsReplace;
